import { Link } from 'react-router-dom'

export function TechnologyCTA({ title, primary }: { title: string; primary: { label: string; route: string } }) {
  return <section className="tech-cta"><div className="container"><span className="tech-kicker">Continue exploring</span><h2>{title}</h2><div className="tech-actions"><Link className="button button--light" to={primary.route}>{primary.label} <span>→</span></Link><Link className="button" to="/contact">Contact Aldapa Systems <span>→</span></Link></div></div></section>
}
